import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ModalComponent } from '@app/shared/components';
import { ActivityFormComponent } from '../forms/activity-form/activity-form.component';
import { TranslateService } from '@ngx-translate/core';
import { Activity } from '@app/shared/models/activity.model';
import { ToastsManager } from "@app/shared/util/toastr.service";

@Component({
    selector: 'app-activity-modal',
    templateUrl: './activity-modal.component.html',
    styleUrls: ['./activity-modal.component.scss']
})
export class ActivityModalComponent implements OnInit {
    @ViewChild(ModalComponent, {static: true}) modal: ModalComponent;
    @ViewChild(ActivityFormComponent, {static: true}) form: ActivityFormComponent;

    @Input() title = '';
    @Input() dropdownItems = [];
    @Input() showErrors = false;

    @Output() submit = new EventEmitter<any>();

    mode = 'create';

    constructor(private toastr: ToastsManager, private translate: TranslateService) {
    }

    ngOnInit() {
    }

    open(activity: Activity = null, mode: string = 'create') {
        this.mode = mode;
        this.modal.open();
        this.form.init(activity);
    }

    close() {
        this.modal.close();
    }

    reset() {
        this.showErrors = false;
        this.form.reset();
    }

    onCancel() {
        this.reset();
        this.close();
    }

    onConfirm() {
        this.showErrors = true;

        const value = this.form.getFormValue();

        if (this.form.valid) {
            this.onCancel();
            this.submit.emit(value);
        } else if (!value.assigned) {
            this.toastr.error(
                this.translate.instant('admin.toolMaintenancePlans.activities.modal.assignRole')
            );
        }
    }
}
